<template>
  <div>

        <section >
                <div class="">
                    <!-- Mobile action buttons -->
                    <div class="d-flex d-md-none gap-2 mb-3" v-if="!isDetailClient">
                        <template v-if="helper.checkAccess('create_deliveries') != -1">
                            <button @click="create" class="btn btn-sm btn-success flex-grow-1">
                                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                <span>{{$t('delivery')}}</span>
                            </button>
                        </template>
                        <div v-if="role === 'owner' || role === 'admin'" class="dropdown">
                            <button class="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-center" type="button" data-bs-toggle="dropdown" aria-expanded="false" style="height: 31px; width: 34px; padding: 0;">
                                <AppIcon name="bi-three-dots-vertical" class="bi bi-three-dots-vertical" style="font-size:14px" />
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end shadow">
                                <li>
                                    <a class="dropdown-item d-flex align-items-center" href="#" @click.prevent="toggleTrashView">
                                        <AppIcon name="bi-trash" class="bi bi-trash me-2 text-danger" />
                                        <span>{{ $t('trash') }}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- Filters section -->
                    <div class="row align-items-end g-2 mb-4" v-if="!isDetailClient" :class="{'d-none d-md-flex': !showFilters}">
                        
                        <!-- Filter Dropdown (Shopify Style) -->
                        <div class="col-12 col-md-auto">
                            <div class="dropdown">
                                <button class="btn btn-outline-secondary dropdown-toggle btn-sm" type="button" id="deliveryFilterDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                    <AppIcon name="bi-funnel" class="bi bi-funnel" /> {{$t('filter')}}
                                    <span v-if="activeFilters.length" class="badge bg-secondary ms-1">{{activeFilters.length}}</span>
                                </button>
                                <button v-if="activeFilters.length" class="btn btn-link btn-sm text-danger text-decoration-none ms-2" type="button" @click.stop="clearAllFilters">
                                    <AppIcon name="bi-x-circle" class="bi bi-x-circle me-1" />{{$t('clear_all')}}
                                </button>
                                <div class="dropdown-menu p-3" aria-labelledby="deliveryFilterDropdown" style="min-width: 300px;" @click.stop>
                                    
                                    <!-- Active Filters -->
                                    <div v-if="activeFilters.length > 0" class="mb-3">
                                        <div v-for="(filter, index) in activeFilters" :key="index" class="mb-2">
                                            <label class="form-label small mb-1">{{$t(filter.key)}}</label>
                                            <div class="input-group input-group-sm" v-if="filter.key === 'total_amount'">
                                                <select v-model="filter.operator" class="form-select" style="max-width: 80px;">
                                                    <option value="gt">{{$t('operator_gt')}}</option>
                                                    <option value="lt">{{$t('operator_lt')}}</option>
                                                    <option value="eq">{{$t('operator_eq')}}</option>
                                                </select>
                                                <input type="number" v-model="filter.value" class="form-control form-control-sm" placeholder="0">
                                                <button class="btn btn-outline-danger" type="button" @click="removeFilter(index)">
                                                    <AppIcon name="bi-trash" class="bi bi-trash" />
                                                </button>
                                            </div>
                                            <div v-else-if="filter.key === 'order'" class="d-flex align-items-center gap-1">
                                                <div class="flex-grow-1">
                                                    <auto-complete
                                                        entity="orders"
                                                        emitEvent="emitAutoCompleteOrderFilter"
                                                        :defaultValue="orderFilterReference"
                                                        @emitAutoCompleteOrderFilter="emitAutoCompleteOrderFilter"
                                                    ></auto-complete>
                                                </div>
                                                <button class="btn btn-outline-danger btn-sm" type="button" @click="removeFilter(index)">
                                                    <AppIcon name="bi-trash" class="bi bi-trash" />
                                                </button>
                                            </div>
                                            <div class="input-group input-group-sm" v-else>
                                                <select v-model="filter.value" class="form-select form-select-sm">
                                                    <option v-for="option in getFilterOptions(filter.key)" :key="option.value" :value="option.value">
                                                        {{$t(option.label)}}
                                                    </option>
                                                </select>
                                                <button class="btn btn-outline-danger" type="button" @click="removeFilter(index)">
                                                    <AppIcon name="bi-trash" class="bi bi-trash" />
                                                </button>
                                            </div>
                                        </div>
                                        <hr class="dropdown-divider">
                                    </div>

                                    <!-- Add Filter Options -->
                                    <div class="d-grid gap-2">
                                        <button v-for="filter in selectableFilters" :key="filter.key" 
                                                class="btn btn-sm btn-outline-primary text-start" 
                                                @click="addFilter(filter)">
                                            <AppIcon name="bi-plus" class="bi bi-plus" /> {{$t(filter.key)}}
                                        </button>
                                    </div>

                                    <!-- Apply and Clear -->
                                    <div class="d-flex justify-content-between align-items-center mt-3">
                                        <button class="btn btn-sm btn-success" @click="applyFilters">
                                            {{$t('apply')}}
                                        </button>
                                        <button v-if="activeFilters.length > 0" class="btn btn-link btn-sm text-decoration-none text-danger p-0" @click="clearAllFilters">
                                            {{$t('clear_all')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Spacer for desktop -->
                        <div class="col d-none d-md-block"></div>
                        
                        <!-- Date picker -->
                        <div class="col-12 col-md-3 col-lg-2">
                            <label class="form-label small d-md-none mb-1">{{$t('filter_by_date')}}</label>
                            <select v-model="dateRangeOption" @change="handleDateRangeChange" class="form-select form-select-sm">
                                <option value="">{{$t('filter_by_date')}}</option>
                                <option value="today">{{$t('today')}}</option>
                                <option value="yesterday">{{$t('yesterday')}}</option>
                                <option value="this_week">{{$t('this_week')}}</option>
                                <option value="last_week">{{$t('last_week')}}</option>
                                <option value="this_month">{{$t('this_month')}}</option>
                                <option value="custom">{{$t('custom_date')}}</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-3 col-lg-2" v-if="dateRangeOption === 'custom'">
                            <label class="form-label small d-md-none mb-1">{{$t('custom_date')}}</label>
                            <date-picker class="w-100" :clearable="true" :editable="false" v-model="range" type="date" range :multi-calendars="1" :placeholder="$t('select_date_range')"></date-picker>
                        </div>
                        
                        <template v-if="helper.checkAccess('create_deliveries') != -1">
                            <div class="col-md-2 d-none d-md-block">
                                <button @click="create" class="btn btn-sm btn-success w-100">
                                    <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                    <span>{{$t('delivery')}}</span>
                                </button>
                            </div>
                        </template>

                    </div>
                <div class="page-table-container mb-6 bg-white rounded shadow">
                    
                    <!-- Trash View -->
                    <div v-if="showTrash && (role === 'owner' || role === 'admin')" class="mt-5">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h6 class="mb-0"><AppIcon name="bi-trash" class="bi bi-trash me-2" />{{$t('trash')}}</h6>
                            <a href="#" class="text-decoration-none small d-flex align-items-center text-secondary" @click.prevent="toggleTrashView">
                                <AppIcon name="bi-arrow-left" class="bi bi-arrow-left me-1" />{{$t('back')}}
                            </a>
                        </div>
                        <table-loading-bar v-if="loading" class="text-center" />
                        <div v-if="!loading" class="table-responsive">
                            <table class="table mb-0 table-borderless table-striped small">
                                <thead>
                                    <tr class="text-secondary">
                                        <th class="pt-4 pb-3 px-6">{{$t('reference')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('client')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('date')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('deleted_at')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('actions')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in trashDeliveries" :key="item.id">
                                        <td class="py-5 px-6">{{item.reference}}</td>
                                        <td class="py-5 px-6">{{item.client ? item.client.name : '-'}}</td>
                                        <td class="py-5 px-6">{{formatDate(item.date)}}</td>
                                        <td class="py-5 px-6">{{formatDate(item.deleted_at, true)}}</td>
                                        <td class="py-5 px-6">
                                            <button @click="viewRow(item)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                                <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                                                {{$t('view')}}
                                            </button>
                                            <button v-if="helper.checkAccess('delete_deliveries') != -1" @click="permanentDeleteDelivery(item)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-danger btn-xs">
                                                <AppIcon name="bi-x-circle" class="bi bi-x-circle" style="font-size:12px" />
                                                {{$t('delete_permanently')}}
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="!loading && trashDeliveries.length === 0" class="text-center py-4 text-muted">
                            <AppIcon name="bi-trash" class="bi bi-trash text-muted" style="font-size: 2rem;" />
                            <p class="mt-2 mb-0">{{$t('trash_empty')}}</p>
                        </div>
                        <div v-if="trashCount > trashDeliveries.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <compact-pagination :pages="trashPagination" :current-page="trashPage" @change="getTrashDeliveries" />
                        </div>
                    </div>


                    <div v-if="!showTrash">
                    <!-- table -->
                    <div data-testid="delivery-table-scroll" class="table-responsive document-list-table">
                        <table class="table mb-0 table-borderless table-striped small sales-document-table" style="--sales-document-table-min-width: 1100px;">
                            <thead>
                                <tr class="text-secondary">
                                    <th class="pt-4 pb-3 px-6" style="width: 40px;">
                                        <div class="form-check mb-0">
                                            <input class="form-check-input" type="checkbox" :checked="areAllSelected" @change="toggleSelectAll">
                                        </div>
                                    </th>
                                    <sortable-table-header v-if="isDocumentColumnVisible('reference')" field="reference" label="reference" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getDeliveries)" />
                                    <sortable-table-header v-if="isDocumentColumnVisible('order')" field="order" label="order" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getDeliveries)" />
                                    <sortable-table-header v-if="isDocumentColumnVisible('client') && !hideClient" field="client" label="client" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getDeliveries)" />
                                    <sortable-table-header v-if="isDocumentColumnVisible('status')" field="status" label="status" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getDeliveries)" />
                                    <sortable-table-header v-if="isDocumentColumnVisible('date')" field="date" label="date" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getDeliveries)" />
                                    <sortable-table-header v-if="isDocumentColumnVisible('created_by')" field="created_by" label="created_by" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getDeliveries)" />
                                    <th v-if="isDocumentColumnVisible('action')" class="pt-4 pb-3 px-6 sales-sticky-action-cell">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <span>{{$t('action')}}</span>
                                            <div v-if="role === 'owner' || role === 'admin'" class="dropdown">
                                                <button class="btn btn-sm btn-link p-0 ms-2 text-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <AppIcon name="bi-three-dots-vertical" class="bi bi-three-dots-vertical" />
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end shadow">
                                                    <li>
                                                        <a class="dropdown-item d-flex align-items-center" href="#" @click.prevent="toggleTrashView">
                                                            <AppIcon name="bi-trash" class="bi bi-trash me-2 text-danger" />
                                                            <span>{{ $t('trash') }}</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="delivery in deliveries" :key="delivery.id" :class="{'table-active': delivery.selected}">
                                <td class="py-5 px-6">
                                    <div class="form-check mb-0">
                                        <input class="form-check-input" type="checkbox" v-model="delivery.selected" @change="changeSelectedItem">
                                    </div>
                                </td>
                                <td v-if="isDocumentColumnVisible('reference')" class="py-5 px-6"><router-link :to="`/deliveries/${delivery.id}`"><b>{{delivery.reference}}</b></router-link></td>
                                <td v-if="isDocumentColumnVisible('order')" class="py-5 px-6"><router-link v-if="delivery.order && delivery.order.reference" :to="`/orders/${delivery.order.id}`">{{delivery.order && delivery.order.reference ? delivery.order.reference : "-"}}</router-link></td>
                                <td v-if="isDocumentColumnVisible('client') && !hideClient" class="py-5 px-6">
                                    <router-link
                                        v-if="delivery.client && delivery.client.name"
                                        :to="`/clients/${delivery.client.id}`"
                                        :title="delivery.client.name"
                                        :aria-label="delivery.client.name"
                                    >{{truncateClientName(delivery.client.name)}}</router-link>
                                </td>
                                <td v-if="isDocumentColumnVisible('status')" class="py-5 px-6">
                                    <div v-if="helper.checkAccess('edit_deliveries') != -1 && !isDeliveryStatusDropdownDisabled(delivery)" class="dropdown">
                                        <button
                                            :id="`delivery-status-${delivery.id}`"
                                            type="button"
                                            class="badge border-0 dropdown-toggle"
                                            :class="getDeliveryStatusBadgeClass(delivery.status)"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            :disabled="isDeliveryStatusDropdownDisabled(delivery)"
                                        >
                                            <span v-if="deliveryStatusUpdatingId === delivery.id" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                            {{ $t(delivery.status) }}
                                        </button>
                                        <ul class="dropdown-menu shadow" :aria-labelledby="`delivery-status-${delivery.id}`">
                                            <li v-for="status in getDeliveryStatusOptions(delivery)" :key="status">
                                                <button
                                                    type="button"
                                                    class="dropdown-item d-flex align-items-center justify-content-between gap-3"
                                                    :class="{ active: delivery.status === status }"
                                                    :disabled="delivery.status === status"
                                                    @click="changeDeliveryStatus(delivery, status)"
                                                >
                                                    <span>{{ $t(status) }}</span>
                                                    <AppIcon name="bi-check-lg" v-if="delivery.status === status" class="bi bi-check-lg" />
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <span v-else class="badge" :class="getDeliveryStatusBadgeClass(delivery.status)">
                                        {{ $t(delivery.status) }}
                                    </span>
                                </td>
                                <td v-if="isDocumentColumnVisible('date')" class="py-5 px-6">{{formatDate(delivery.date)}}</td>
                                <td v-if="isDocumentColumnVisible('created_by')" class="py-5 px-6">
                                    {{delivery.user ? delivery.user.name : '-'}}
                                </td>
                                <td v-if="isDocumentColumnVisible('action')" class="py-5 px-6 sales-sticky-action-cell">
                                    <div class="sales-row-actions">
                                        <div v-if="!['draft', 'canceled'].includes(delivery.status) && helper.checkAccess('create_invoices') > 0" class="dropdown d-inline-block">
                                            <button class="btn btn-primary btn-xs dropdown-toggle" type="button" :id="`delivery-transfer-${delivery.id}`" data-bs-toggle="dropdown" aria-expanded="false">
                                                <AppIcon name="bi-arrow-left-right" class="bi bi-arrow-left-right" style="font-size:12px" /> {{$t('transfert')}}
                                            </button>
                                            <ul class="dropdown-menu dropdown-menu-end" :aria-labelledby="`delivery-transfer-${delivery.id}`">
                                                <li><a class="dropdown-item" style="cursor:pointer" @click="transferInvoice(delivery)"> {{$t('invoice')}}</a></li>
                                            </ul>
                                        </div>
                                        <button v-if="delivery.status != 'draft'" @click="viewRow(delivery)" class="btn btn-primary btn-xs">
                                           <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                                           {{$t('delivery_note')}}
                                        </button>
                                        <button v-if="helper.checkAccess('edit_deliveries') != -1" @click="editRow(delivery)" class="btn btn-primary btn-xs">
                                            <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                                            {{$t('edit')}}
                                        </button>
                                        <button v-if="helper.checkAccess('delete_deliveries') != -1" @click="deleteRow(delivery)" class="btn btn-primary btn-xs">
                                            <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                                            {{$t('delete')}}
                                        </button>
                                    </div>
                                </td>
                            </tr>

                            </tbody>
                        </table>

                        <div v-if="count > deliveries.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <compact-pagination :pages="pagination" :current-page="page" @change="getDeliveries" />
                        </div>
                        <table-loading-bar v-if="loading" class="page-table-state document-list-loading" />
                    </div>
                    <!-- table -->
                    <div v-if="loading === false && !deliveries.length && !isFiltered" class="page-table-state document-list-empty text-center my-5 bg-white rounded shadow-sm border" style="border-style: dashed !important;">
                        <AppIcon name="bi-truck" class="bi bi-truck text-muted" style="font-size: 3rem;" />
                        <h4 class="mt-3">{{ $t('no_deliveries_added') }}</h4>
                        <p class="text-muted">{{ $t('start_by_adding_deliveries') }}</p>
                        <template v-if="helper.checkAccess('create_deliveries') != -1">
                            <button class="btn btn-outline-primary mt-2" @click="create">
                                {{ $t('create_first_delivery') }}
                            </button>
                        </template>
                    </div>
                    <div v-if="loading === false && !deliveries.length && isFiltered" class="page-table-state document-list-empty text-center">{{$t('no_delivery_found')}}.</div>

                </div>
                    </div>

                <div v-if="!showTrash" class="col-sm-7">
                    {{$t('show')}}
                    <select v-model="per_page" class="form-select mb-3" name="Resulats" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    {{$t('entities')}}
                </div>
                </div>
        </section>

        <!-- Bulk Action Bar -->
        <div v-if="isSelectedItem" class="position-fixed bottom-0 start-50 translate-middle-x mb-4 p-3 bg-white shadow rounded d-flex align-items-center gap-3" style="z-index: 1050; border: 1px solid #dee2e6; min-width: 300px; justify-content: space-between;">
            <div class="d-flex align-items-center">
                <span class="fw-bold me-2">{{ selectedCount }}</span>
                <span class="text-muted">{{$t('selected')}}</span>
            </div>
            <div class="d-flex gap-2">
                <div v-if="helper.checkAccess('create_invoices') > 0" class="dropdown dropup">
                    <button class="btn btn-primary btn-sm dropdown-toggle d-flex align-items-center" type="button" id="bulkTransferDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                        <AppIcon name="bi-arrow-left-right" class="bi bi-arrow-left-right me-1" /> {{$t('transfert')}}
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="bulkTransferDropdown">
                        <li><a class="dropdown-item" style="cursor:pointer" @click="transferSelectedToInvoice"> {{$t('invoice')}}</a></li>
                    </ul>
                </div>
                <button v-if="helper.checkAccess('delete_deliveries') != -1" class="btn btn-danger btn-sm d-flex align-items-center" @click="deleteSelected">
                    <AppIcon name="bi-trash" class="bi bi-trash me-1" /> {{$t('delete')}}
                </button>
            </div>
        </div>

    
        <!-- create Modal -->
        <add-edit-delivery-modal 
            v-if="createModalisOpen" 
            @modalClosed="createModalisOpen = false"
            modalId="create-delivery-modal-01" 
            :isModalOpen="createModalisOpen" 
            :data="delivery" 
            action="create"
            @refresh="refresh"
        ></add-edit-delivery-modal>
        <!-- create modal -->

        <!-- Edit Modal -->
        <add-edit-delivery-modal 
            v-if="editModalisOpen" 
            @modalClosed="editModalisOpen = false" 
            modalId="edit-delivery-modal-01" 
            :isModalOpen="editModalisOpen"  
            :data="delivery" 
            action="update" 
            @refresh="refresh"
        ></add-edit-delivery-modal>
        <!-- Edit modal -->

        <!-- delivery modal -->
        <invoice-template-modal 
            v-if="invoiceModalisOpen" 
            @modalClosed="invoiceModalisOpen = false" 
            modalId="invoice-delivery-modal-01" 
            :isModalOpen="invoiceModalisOpen"  
            :data="delivery" 
            type="delivery">
        </invoice-template-modal>
        <!-- delivery modal -->

        <!-- create Modal -->
        <add-edit-invoice-modal 
            v-if="createInvoiceModalState" 
            @modalClosed="createInvoiceModalState = false"
            modalId="create-invoice-modal-01" 
            :isModalOpen="createInvoiceModalState" 
            :data="delivery" 
            action="transfer"
        ></add-edit-invoice-modal>
        <!-- create modal -->


        <!-- create Modal -->
        <add-edit-return-modal 
            v-if="createReturnModalState" 
            @modalClosed="createReturnModalState = false"
            modalId="create-return-modal-01" 
            :isModalOpen="createReturnModalState" 
            :data="delivery" 
            action="transfer"
        ></add-edit-return-modal>
        <!-- create modal -->

        <!-- create Modal -->
        <add-edit-credit-invoice-modal 
            v-if="createCreditInvoiceModalState" 
            @modalClosed="createCreditInvoiceModalState = false"
            modalId="create-return-modal-01" 
            :isModalOpen="createCreditInvoiceModalState" 
            :data="delivery" 
            action="transfer"
        ></add-edit-credit-invoice-modal>
        <!-- create modal -->

  </div>
</template>

<script>
import helper from '../helper'
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import AddEditDeliveryModal from './delivery/AddEditDeliveryModal'
import AddEditInvoiceModal from './invoice/AddEditInvoiceModal'
import AddEditReturnModal from './return/AddEditReturnModal'
import AddEditCreditInvoiceModal from './creditInvoice/AddEditInvoiceModal'

import InvoiceTemplateModal from './invoiceLayout/InvoiceTemplateModal';
import AutoComplete from './autocomplete/AutoComplete';
import sortableList from '../mixins/sortableList';
import { getSalesDocumentColumnDefaults, getSalesDocumentColumnMetadataKey } from '../constants/salesDocumentColumns';

export default {
  name: 'Delivery',
  persistedFilterState: {
    key: 'deliveries',
    fields: ['activeFilters', 'orderFilterReference', 'dateRangeOption', 'range', 'start', 'end', 'per_page', 'sortField', 'sortDirection'],
    dateFields: ['range'],
  },
  mixins: [sortableList],
  components : {
    DatePicker,
    AddEditDeliveryModal,
    InvoiceTemplateModal,
    AddEditInvoiceModal,
    AddEditReturnModal,
    AddEditCreditInvoiceModal,
    AutoComplete
   },
    props : [
    'openCreateModal',
    'client_id',
    'order_id',
    'user_id',
    'inventory_id',
    'product_id',
    'keyword',
    'isDetailClient',
    'products',
    'client',
    'showFilters'
    ],
  data(){
    return {
        loading : false,
        isSelectedItem : false,
        search :'',
        deliveries : [],
        count : 0,
        page : 1,
        showTrash : false,
        trashDeliveries: [],
        trashCount: 0,
        trashPage: 1,
        trashPagination: [],
        transactions : [],
        createInvoiceModalState : false,
        delivery : {
            id : null,
            reference : `DEL-00`,
            date : '',
            notes : '',
            products : [],
            order_id : null,
            status : 'pending'
        },
        range: [],
        start : null,
        end : null,
        dateRangeOption: '',
        activeFilters: [],
        availableFilters: [
            { 
                key: 'status', 
                options: [
                    { value: 'draft', label: 'draft' },
                    { value: 'pending', label: 'pending' },
                    { value: 'delivered', label: 'delivered' },
                    { value: 'canceled', label: 'canceled' }
                ] 
            },
            {
                key: 'order',
                options: []
            }
        ],
        deliveryProducts : [],
        totalHtPrice : 0,
        createModal : null,
        editModal : null,
        invoiceModalStatus : false,
        invoiceModalisOpen : false,
        createModalisOpen :false,
        editModalisOpen :false,
        createSuplierState : false,
        per_page : 25,
        pagination : [],
        hideClient : false,
        url : '',
        ClientState : true,
        createClientState : false,
        createReturnModalState : false,
        createCreditInvoiceModalState : false,
        deliveryStatusUpdatingId: null,
        deliveryStatusOptions: ['pending', 'delivered', 'canceled'],
        orderFilterReference: ''
    }
  },
  mounted(){
    // Initialize this_month date range
    // this.handleDateRangeChange()
    this.getDeliveries()
  },
  watch : {
    range(val) {
        if (val && val.length === 2 && val[0] && val[1]) {
            this.start = moment(val[0]).format('YYYY-MM-DD')
            this.end = moment(val[1]).format('YYYY-MM-DD')
            this.getDeliveries(1)
        } else {
            this.start = null
            this.end = null
            this.getDeliveries(1)
        }
    },
    per_page(){
        this.getDeliveries(this.page)
    },
    openCreateModal(){       
        this.getDeliveries()
        this.create()
    },
    createModalisOpen(){
        this.getDeliveries()
        this.$emit('createModalStatus',this.createModalisOpen)
    },
    async keyword(){
        if(this.keyword.length > 2){
            const response = await helper.customGet(`${process.env.VUE_APP_API}/deliveries?keyword=${this.keyword}&per_page=${this.per_page}`)
            this.deliveries = response.data.data
            for(let i = 0 ; i < this.deliveries.length ; i++){
                this.$set(this.deliveries[i], 'selected', false)
            }
            this.count = response.data.count
        }
        if(this.keyword == '') return this.getDeliveries()
    },
  },    
  methods : {
    isDocumentColumnVisible(key) {
      return this.documentColumns[key] !== false
    },
    truncateClientName(name) {
      if (!name) return '-'
      return name.length > 20 ? `${name.slice(0, 20)}...` : name
    },
    async create(){

        this.clearForm()

        this.createModalisOpen = true;

        if(this.client){
            this.delivery.client = this.client
            this.delivery.client_id = this.client.id
        }

        if(this.order_id){
            this.delivery.order_id = this.order_id
        }

        if(this.products){
            for(let i = 0 ; i < this.products.length ; i++){
                this.products[i].label = this.products[i].product_label 
            }
            this.delivery.products = this.products
        }


        this.delivery.products.push({
            label : '',
            id : null,
            quantity : 0,
            price : 0,
            discount : 0,
            vat : this.business.vat,
            total : 0,
            sub_total : 0,
        })

        this.delivery.date = moment().format('YYYY-MM-DD')

       
    }, 
    editRow(row){
        this.editModalisOpen = true;
        this.delivery = row 
        this.delivery.supplier_id = row.supplier && row.supplier.id ? row.supplier.id : null
        this.delivery.date = moment(this.delivery.date).format('YYYY-MM-DD')
    },
    getDeliveryStatusBadgeClass(status){
        return {
            'bg-info': status === 'draft',
            'bg-success': status === 'delivered' || status === 'completed',
            'bg-warning': status === 'partially_delivered',
            'bg-danger': status === 'canceled',
            'bg-secondary': status === 'pending'
        }
    },
    getDeliveryStatusOptions(delivery){
        return ['delivered', 'completed'].includes(delivery.status)
            ? ['canceled']
            : this.deliveryStatusOptions
    },
    isDeliveryStatusDropdownDisabled(delivery){
        return this.deliveryStatusUpdatingId === delivery.id
            || ['draft', 'canceled'].includes(delivery.status)
    },
    async changeDeliveryStatus(delivery, status){
        if (this.isDeliveryStatusDropdownDisabled(delivery) || delivery.status === status) return

        const previousStatus = delivery.status
        this.deliveryStatusUpdatingId = delivery.id
        this.$set(delivery, 'status', status)

        try{
            await helper.customPatch(
                `${process.env.VUE_APP_API}/deliveries/${delivery.id}`,
                { status },
                { showToast: true }
            )
        }catch(error){
            this.$set(delivery, 'status', previousStatus)
        }finally{
            await this.getDeliveries(this.page)
            this.deliveryStatusUpdatingId = null
        }
    },
    //update delivery
    viewRow(row){
        this.clearForm()
        this.delivery = row 
        this.invoiceModalisOpen = true;
    },
    async deleteRow(row){
        this.$swal.fire({
            title: `${this.$t('are_you_sure')}?`,
            text : this.$t('you_cant_revert'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes_delete_it')
        }).then(async (result) => {
            if (result.isConfirmed) {
                await helper.customDelete(`${process.env.VUE_APP_API}/deliveries/${row.id}`)
                this.deliveries = helper.withoutDeletedRecords(this.deliveries, row.id)
                this.count = Math.max(0, this.count - 1)
            }
        })
    },
    clearForm(){
        this.delivery = {
            id : null,
            reference : '',
            date : '',
            products : [],
            status : 'pending',
        }
        this.delivery.products = []
        
    },
    async getDeliveries(page){
        try{
            this.loading = true
            this.page = page ? page : 1
            
            // Extract filters
            const statusFilter = this.activeFilters.find(f => f.key === 'status');
            const status = statusFilter ? statusFilter.value : 'all';

            const orderFilter = this.activeFilters.find(f => f.key === 'order');
            const amountFilter = this.activeFilters.find(f => f.key === 'total_amount');

            // Build query params
            const params = new URLSearchParams();
            params.append('page', this.page);
            params.append('per_page', this.per_page);
            this.appendSortParams(params);

            if (this.start) {
                params.append('start', this.start);
                params.append('end', this.end);
            }

            if (status !== 'all') params.append('status', status);
            if (orderFilter && orderFilter.value) params.append('order_id', orderFilter.value);
            
            if (amountFilter && amountFilter.value !== null && amountFilter.value !== '') {
                params.append('amount_operator', amountFilter.operator);
                params.append('amount_value', amountFilter.value);
            }
            
            // Add optional filters if they exist
            if (this.client_id) params.append('client_id', this.client_id);
            if (this.order_id) params.append('order_id', this.order_id);
            if (this.inventory_id) params.append('inventory_id', this.inventory_id);
            if (this.product_id) params.append('product_id', this.product_id);
            if (this.user_id) params.append('user_id', this.user_id);
            if (this.keyword && this.keyword.length > 2) params.append('keyword', this.keyword);

            let url = `${process.env.VUE_APP_API}/deliveries?${params.toString()}`;

            const response = await helper.customGet(url)
            this.deliveries = response.data.data

            for(let i = 0 ; i < this.deliveries.length ; i++){
                this.$set(this.deliveries[i], 'selected', false)
            }
            
            this.count = response.data.count
            if(this.per_page != response.data.per_page){
                this.per_page = response.data.per_page
            }
            //pagination
            this.pagination = []
            let MaxPagination = Math.ceil(this.count / this.per_page )
            for(let i = 1 ; i <= MaxPagination ;i++){
                this.pagination.push(i)
            }
            this.loading = false
        }catch(error){
            this.loading = false
        }

    },
    async transferInvoice(delivery){

        delivery.total = delivery.products && delivery.products.length ? delivery.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0;
        this.delivery = delivery
        this.createInvoiceModalState = !this.createInvoiceModalState

    },
    transferSelectedToInvoice() {
        const mergedData = this.validateBulkTransfer();
        if (!mergedData) return;

        this.delivery = mergedData;
        this.createInvoiceModalState = true;
    },
    changeSelectedItem(){
        this.isSelectedItem = this.deliveries.find(delivery => delivery.selected === true ) ? true : false
    },
    async transferCreditInvoice(delivery){

        delivery.total = delivery.products && delivery.products.length ? delivery.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0;

        this.delivery = delivery
        this.createCreditInvoiceModalState = !this.createCreditInvoiceModalState

    },
    async transferReturn(delivery){
        delivery.total = delivery.products && delivery.products.length ? delivery.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0;

        this.delivery = delivery
        this.createReturnModalState = !this.createReturnModalState

    },
    async confirmDelivery(delivery){
        this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text : this.$t('you_cant_revert'),
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        showLoaderOnConfirm: true,
        preConfirm: async () => {

            try{

                const deliveryObject = {
                    id : null,
                    date : delivery.date,
                    notes : delivery.notes,
                    products : delivery.products,
                    client_id : delivery.client_id,
                    status : delivery.status,
                    total : delivery.total
                }

                await helper.customPost(`${process.env.VUE_APP_API}/deliveries`,{
                    ...deliveryObject, 
                    transaction : {
                        amount : 0
                    }, 
                    products : deliveryObject.products},
                    {
                        showToast:false
                    })

            }catch(error){
                this.$swal.showValidationMessage(`Request failed: ${error}`)
            }
        },
        }).then(async (result) => {
            if (result.isConfirmed) {

                window.vueOpener.open({
                    message: `Livraison créée avec succès`,
                    type: 'success',
                    position : 'bottom'
                });

                this.getDeliveries()

            }
        })
    },
    createInvoiceModal(data){
        this.createInvoiceModalState = data
    },
    createReturnModal(data){
        this.createReturnModalState = data
    },
    createCreditInvoiceModal(data){
        this.createCreditInvoiceModalState = data
    },
    refresh(){
        this.getDeliveries()
    },
    //helper functions
    formatDate(date) { return helper.formatDate(date) },
    formatMoney(number) { return helper.formatMoney(number);},
    formatReference(number,id) { return helper.formatReference(number,id);},
    // Handle date range selection
    handleDateRangeChange() {
      const option = this.dateRangeOption
      if (!option || option === 'custom') {
        if (option === 'custom') return
        this.range = []
        this.start = null
        this.end = null
        this.getDeliveries()
        return
      }

      const today = moment()
      let start, end

      switch(option) {
        case 'today':
          start = today.clone().startOf('day')
          end = today.clone().endOf('day')
          break
        case 'yesterday':
          start = today.clone().subtract(1, 'days').startOf('day')
          end = today.clone().subtract(1, 'days').endOf('day')
          break
        case 'this_week':
          start = today.clone().startOf('isoWeek')
          end = today.clone().endOf('isoWeek')
          break
        case 'last_week':
          start = today.clone().subtract(1, 'weeks').startOf('isoWeek')
          end = today.clone().subtract(1, 'weeks').endOf('isoWeek')
          break
        case 'this_month':
          start = today.clone().startOf('month')
          end = today.clone().endOf('month')
          break
        default:
          return
      }

      this.range = [start.toDate(), end.toDate()]
      this.start = start.format('YYYY-MM-DD')
      this.end = end.format('YYYY-MM-DD')
      this.getDeliveries()
    },
    addFilter(filter) {
        if (!this.isFilterActive(filter.key)) {
            if (filter.key === 'total_amount') {
                 this.activeFilters.push({
                    key: filter.key,
                    operator: 'gt',
                    value: 0
                });
            } else if (filter.key === 'order') {
                this.orderFilterReference = '';
                this.activeFilters.push({
                    key: filter.key,
                    value: null
                });
            } else {
                const defaultVal = filter.options[0].value;
                this.activeFilters.push({ 
                    key: filter.key, 
                    value: defaultVal 
                });
            }
        }
    },
    removeFilter(index) {
        const filter = this.activeFilters[index];
        if (filter && filter.key === 'order') {
            this.orderFilterReference = '';
        }
        this.activeFilters.splice(index, 1);
    },
    isFilterActive(key) {
        return this.activeFilters.some(f => f.key === key);
    },
    getFilterOptions(key) {
        const filter = this.availableFilters.find(f => f.key === key);
        return filter ? filter.options : [];
    },
    applyFilters() {
        this.getDeliveries();
    },
    clearAllFilters() {
        this.activeFilters = [];
        this.orderFilterReference = '';
        this.getDeliveries();
    },
    emitAutoCompleteOrderFilter(data) {
        const orderFilter = this.activeFilters.find(f => f.key === 'order');
        if (data.clear_input) {
            if (orderFilter) {
                orderFilter.value = null;
            }
            this.orderFilterReference = '';
            return;
        }
        if (data.result && orderFilter) {
            orderFilter.value = data.result.id;
            this.orderFilterReference = data.result.reference;
        }
    },
    toggleSelectAll() {
      const newState = !this.areAllSelected;
      this.deliveries.forEach(item => item.selected = newState);
      this.changeSelectedItem();
    },
    async deleteSelected() {
      const selectedIds = this.deliveries.filter(item => item.selected).map(item => item.id);
      if (selectedIds.length === 0) return;

      this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text: this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
      }).then(async (result) => {
        if (result.isConfirmed) {
            this.loading = true;
            try {
                const results = await Promise.allSettled(selectedIds.map(id => helper.customDelete(`${process.env.VUE_APP_API}/deliveries/${id}`)));
                const deletedIds = helper.fulfilledRecordIds(selectedIds, results);
                this.deliveries = helper.withoutDeletedRecords(this.deliveries, deletedIds);
                this.count = Math.max(0, this.count - deletedIds.length);
                if (deletedIds.length !== selectedIds.length) throw results.find(result => result.status === 'rejected').reason;
                this.isSelectedItem = false;
                this.$toast.open({
                    message: this.$t('deliveries_deleted_successfully'),
                    type: 'success',
                    position: 'bottom'
                });
            } catch (error) {
                this.$toast.open({
                    message: this.$t('error_occurred'),
                    type: 'error',
                    position: 'bottom'
                });
            } finally {
                this.loading = false;
            }
        }
      });
    },
    validateBulkTransfer() {
        const selectedDeliveries = this.deliveries.filter(item => item.selected);
        if (selectedDeliveries.length === 0) return null;

        const clientId = selectedDeliveries[0].client_id;
        const allSameClient = selectedDeliveries.every(d => d.client_id === clientId);

        if (!allSameClient) {
            this.$swal.fire(
                this.$t('error'),
                this.$t('select_deliveries_same_client'),
                'error'
            );
            return null;
        }
        
        // Aggregate products
        let allProducts = [];
        selectedDeliveries.forEach(d => {
            if (d.products && d.products.length) {
                allProducts = allProducts.concat(d.products);
            }
        });

        // Calculate total
        const total = allProducts.reduce((acc, p) => acc + (p.total || 0), 0);

        return {
            id: null,
            delivery_ids: selectedDeliveries.map(d => d.id),
            client_id: clientId,
            status : 'pending',
            client: selectedDeliveries[0].client,
            date: moment().format('YYYY-MM-DD'),
            products: allProducts,
            total: total
        };
    },
    async toggleTrashView() {
        this.showTrash = !this.showTrash;
        if (this.showTrash) {
            this.trashPage = 1;
            await this.getTrashDeliveries(1);
        }
    },
    async getTrashDeliveries(page) {
        try {
            this.loading = true;
            this.trashPage = page ? page : 1;
            const url = `${process.env.VUE_APP_API}/deliveries/trash?page=${this.trashPage}&per_page=50`;
            const response = await helper.customGet(url);
            this.trashDeliveries = response.data.data;
            this.trashCount = response.data.count;
            
            this.trashPagination = [];
            let MaxPagination = Math.ceil(this.trashCount / 50);
            for(let i = 1; i <= MaxPagination; i++) {
                this.trashPagination.push(i);
            }
        } catch (error) {
            helper.handleError(error);
        } finally {
            this.loading = false;
        }
    },
    async permanentDeleteDelivery(item) {
        this.$swal.fire({
            title: `${this.$t('are_you_sure')}?`,
            text: this.$t('you_cant_revert'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: this.$t('yes_delete_it')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await helper.customDelete(`${process.env.VUE_APP_API}/deliveries/${item.id}/permanent`);
                    this.trashDeliveries = helper.withoutDeletedRecords(this.trashDeliveries, item.id);
                } catch (error) {
                    helper.handleError(error);
                }
            }
        });
    }
  },
  computed : {
    selectableFilters() {
        return this.availableFilters.filter(f => !this.isFilterActive(f.key));
    },
    isFiltered() {
      return (this.activeFilters.length > 0) ||
             (this.dateRangeOption && this.dateRangeOption !== '') ||
             (this.keyword && this.keyword.length > 0) ||
             (this.range && this.range.length > 0);
    },
    isOwner(){ return ['owner', 'admin'].includes(this.$store.getters.ROLE) },
    role(){ return this.$store.getters.ROLE },
    helper(){ return helper },
    permissions(){ return this.$store.getters.PERMISSIONS },
    business(){ return this.$store.getters.BUSINESS},
    documentColumns() {
      return {
        ...getSalesDocumentColumnDefaults('delivery'),
        ...(this.business?.metadata?.[getSalesDocumentColumnMetadataKey('delivery')] || {})
      }
    },
    total(){ return this.delivery.products.length ? this.delivery.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0},
    sub_total(){ return this.delivery.products.length ? this.delivery.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0},
    selectedCount() {
      return this.deliveries.filter(item => item.selected).length;
    },
    areAllSelected() {
      return this.deliveries.length > 0 && this.deliveries.every(item => item.selected);
    }
  }
}
</script>

<style scoped>
    .document-list-table {
        min-height: 70vh;
        position: relative;
    }

    .document-list-loading {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
    }

    .document-list-empty {
        min-height: 70vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>
